import React, { useRef } from 'react';
import { Select } from 'antd';

/**
 * Select با رفتار پیش‌فرض Ant Design + بستن با کلیک دوم روی فیلد.
 * open را کنترل نمی‌کنیم تا انتخاب آیتم خراب نشود؛ فقط وقتی منو باز است
 * و روی .ant-select-selector کلیک شود، preventDefault منوی را می‌بندد.
 */
const AppSelect = React.forwardRef(({ onDropdownVisibleChange, onMouseDown, ...rest }, ref) => {
  const openRef = useRef(false);

  return (
    <Select
      ref={ref}
      {...rest}
      onDropdownVisibleChange={(visible) => {
        openRef.current = visible;
        onDropdownVisibleChange?.(visible);
      }}
      onMouseDown={(e) => {
        const onSelector = e.target.closest?.('.ant-select-selector');
        if (onSelector && openRef.current && !rest.disabled) {
          e.preventDefault();
          e.stopPropagation();
        }
        onMouseDown?.(e);
      }}
    />
  );
});

AppSelect.displayName = 'AppSelect';

export const { Option, OptGroup } = Select;
export default AppSelect;
